type TProps = {
  className?: string;
};
export default function Logo(props: TProps) {
  return (
    <img
      src="/logo.svg"
      alt="Логотип сайта - елка"
      className={props.className}
    />
  );
}
